const isCampaignClosed = (ctx, campaign) =>
  campaign?.isClosed && !ctx?.resolvedUrl?.includes('holding')

export default isCampaignClosed
